import * as React from 'react';
import { MenuItem } from '@shapeable/types';

export type MenuItemsNavigation = {
  items: MenuItem[];
  name?: string;
}

export const MenuItemsContext = React.createContext<MenuItemsNavigation>({ items: [], name: undefined });
export const MenuItemsProvider = MenuItemsContext.Provider;